import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface CartState {
    selectedCartId?: string;
    dismissedInstructions?: boolean;
}

const initialState: CartState = {
    selectedCartId: localStorage?.getItem('selectedCartId') ?? undefined,
    dismissedInstructions: localStorage?.getItem('dismissedInstructions') === 'true' ? true : undefined,
};

export const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        setSelectedCart: (state, action: PayloadAction<string>) => {
            state.selectedCartId = action.payload
            localStorage?.setItem('selectedCartId', String(action.payload));
        },
        setDismissedInstructions: (state, action: PayloadAction<boolean>) => {
            state.dismissedInstructions = action.payload;
            localStorage?.setItem('dismissedInstructions', String(action.payload));
        },
        clearSelectedCart: (state) => {
            state.selectedCartId = undefined;
            localStorage?.removeItem('selectedCartId');
        },

    },
});

export const {
    setSelectedCart,
    clearSelectedCart,
    setDismissedInstructions
} = cartSlice.actions;

export default cartSlice.reducer;